<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            <router-link
                v-if="linked"
                div="span"
                :to="{
                    name: 'ven-cockpit-chart',
                    params: { tipo: datacontent.titulo },
                }"
            >
                {{ title }}
            </router-link>
            <div v-else>{{ title }}</div>

            <div
                v-if="info != null"
                style="display: inline-block; cursor: pointer; right: 2%; position: absolute"
            >
                <b-icon icon="information" v-tippy :title="getT(info)" />
            </div>
        </div>

        <!-- CONTEÚDO -->
        <div
            ref="chartContent"
            class="chart-content big-number-content"
            v-if="!noData && !isLoading"
        >
            <div class="big-number-wrapper">
                <div class="big-number" v-if="datacontent.currency">
                    <div
                        class="big-number-currency"
                        ref="currencyValue"
                    >
                        {{ getDecimal(datacontent.value, null, true) }}
                    </div>
                </div>

                <div class="big-number" v-else>
                    <div class="big-number-value">
                        {{ getDecimal(datacontent.value, 0) }}
                    </div>
                </div>
            </div>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer bn" v-if="!noData && !isLoading && showPercentage(tituloGrafico)">
            <div class="big-number-extra-result">
                <span v-if="datacontent.extotal">{{ datacontent.extotal }}</span>
                <span v-if="datacontent.expercent">
                    &nbsp;- {{ getDecimal(datacontent.expercent, 2) }} %
                </span>
            </div>
            <div
                class="big-number-result"
                v-if="datacontent.compare && showPercent"
                :class="
                    datacontent.result != 0 && !extraInfoNoStyle
                        ? datacontent.positivo
                            ? 'positivo'
                            : 'negativo'
                        : ''
                "
            >
                <svg
                    class="svg-icons"
                    v-if="datacontent.up && datacontent.result != 0 && !extraInfoNoStyle"
                >
                    <use :xlink:href="require('@/assets/img/icons/arrow-up.svg') + '#layer'"></use>
                </svg>
                <svg class="svg-icons" v-else-if="datacontent.result != 0 && !extraInfoNoStyle">
                    <use
                        :xlink:href="require('@/assets/img/icons/arrow-down.svg') + '#layer'"
                    ></use>
                </svg>
                <span>{{ getDecimal(datacontent.result, 2) }} %</span>
            </div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data" v-if="noData && !isLoading">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>

        <!-- CARREGANDO -->
        <div class="no-data" v-if="isLoading">
            <svg class="loading">
                <use :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('carregando') }}...</div>
        </div>
    </div>
</template>

<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import CockpitVendasService from '@/services/CockpitVendasService';
import CockpitDespesasService from '@/services/CockpitDespesasService';
import CockpitAgroService from '@/services/agro/cockpit/CockpitAgroService';
import GeoanaliseOcorrenciaService from '@/services/agro/geoanalise/GeoanaliseOcorrenciaService';
import paleta from '@/functions/color/paleta.js';

export default {
    extends: CockpitChart,
    props: {
        title: {
            type: String,
            default: '',
        },
        datacontent: {
            type: Object,
            default: () => {
                return {};
            },
        },
        filtro: {
            type: Object,
            default: () => {
                return {};
            },
        },
        linked: {
            type: Boolean,
            default: false,
        },
        module: {
            type: String,
            default: 'VENDAS', // vendas, despesas, promotor
        },
        showPercent: {
            type: Boolean,
            default: true,
        },
        info: {
            type: String,
            default: null,
        },
        tituloGrafico: {
            type: String,
            default: '',
        },
        extraInfoNoStyle: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: null,
            isLoading: true,
            error: false,
            numberFormat: null,
            curFormatOptions: {},
            svgResultStyle: {},
            resultStyle: {},
            listChartsRemovePercent: ['chart-titulos-por-data'],
        };
    },
    created() {
        switch (this.module) {
            case 'DESPESAS':
                this.service = new CockpitDespesasService(this.$http, this.$router);
                break;
            case 'VENDAS':
                this.service = new CockpitVendasService(this.$http, this.$router);
                break;
            case 'AGRO':
                this.service = new CockpitAgroService(this.$http, this.$router);
                break;
            case 'GEOANALISEOCORRENCIA':
                this.service = new GeoanaliseOcorrenciaService(this.$http, this.$router);
                break;
        }

        this.noData ? this.loadData() : (this.isLoading = false);
    },
    mounted() {
        if (this.$el != undefined) {
            this.$el.style.setProperty('--positivo', paleta.colors.green);
            this.$el.style.setProperty('--negativo', paleta.colors.red);
        }
    },
    computed: {
        noData() {
            return !this.datacontent || this.datacontent.value == undefined || this.error;
        },
    },
    methods: {
        loadData() {
            this.isLoading = true;
            this.service
                .getChartByTitulo(this.datacontent.titulo, this.filtro)
                .then((r) => {
                    this.error = false;
                    if (r) {
                        this.$emit('update-content', r);
                    } else {
                        console.warn(`Card vazio: ${this.datacontent.titulo}`);
                    }
                })
                .catch((e) => {
                    this.error = true;
                    console.error(`Erro em ${this.datacontent.titulo}`, e);
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        showPercentage(tituloGrafico) {
            return !this.listChartsRemovePercent.includes(tituloGrafico);
        },
    },
};
</script>

<style lang="scss">
:root {
    --positivo: #4caf50;
    --negativo: #f44336;
}
.big-number {
    width: 100%;
}
.disabled {
    opacity: 0.4;
}

.big-number-result {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.big-number-extra-result {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.big-number-result.positivo {
    color: var(--positivo);

    .svg-icons {
        fill: var(--positivo);
    }
}

.big-number-result.negativo {
    color: var(--negativo);

    .svg-icons {
        fill: var(--negativo);
    }
}

.big-number-result {
    color: #898989;
}

.big-number-currency {
    font-size: clamp(0.75rem, 5vw, 2.5rem);
    white-space: nowrap;
}
</style>
